import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-046c75c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  id: "mydiv",
  class: "main-div-userinquiry-company"
}
const _hoisted_4 = { class: "searchCompany-div margin-top-bottom-20" }
const _hoisted_5 = { class: "searchCompany-left-div" }
const _hoisted_6 = {
  key: 0,
  class: "adjusting-position fs-5"
}
const _hoisted_7 = {
  key: 0,
  class: "searchCompany-right-div"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "adjusting-position fs-5 des-select",
  style: {"width":"99% !important","margin-left":"10px","margin-right":"1%"}
}
const _hoisted_10 = { style: {"width":"calc(100% - 16px)"} }
const _hoisted_11 = { id: "tblUserListInfo" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"7.5%"} }, "User ID", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8.6%"} }, "Given Name", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8.7%"} }, "Family Name", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"16%"} }, "E-mail", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"11%"} }, "Department", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8.5%"} }, "Title", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8.5%"} }, "Status", -1 /* HOISTED */))
const _hoisted_19 = {
  key: 0,
  colspan: "4",
  disabled: ""
}
const _hoisted_20 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_21 = {
  key: 1,
  id: "tblbodydiv",
  style: {"overflow":"auto"}
}
const _hoisted_22 = { id: "tblUserListInfo" }
const _hoisted_23 = { id: "tbltbody" }
const _hoisted_24 = { style: {"width":"7.5%"} }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { style: {"width":"8.6%"} }
const _hoisted_27 = { style: {"width":"8.7%"} }
const _hoisted_28 = { style: {"width":"16%"} }
const _hoisted_29 = { style: {"width":"11%"} }
const _hoisted_30 = { style: {"width":"8.5%"} }
const _hoisted_31 = { style: {"width":"8.5%"} }
const _hoisted_32 = {
  key: 0,
  style: {"width":"7.8%","border":"none"},
  disabled: ""
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  style: {"width":"7.8%","border":"none"},
  disabled: ""
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 2,
  style: {"width":"7.8%","border":"none"},
  disabled: ""
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 3,
  style: {"width":"7.8%","border":"none"},
  disabled: ""
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading || $setup.store.getters.stationListData == null)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading || $setup.store.getters.stationListData == null
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    ($setup.store.getters.Flg != 'UserList')
      ? (_openBlock(), _createBlock($setup["UserNavigation"], {
          key: 1,
          menuTile: $setup.title
        }, null, 8 /* PROPS */, ["menuTile"]))
      : (_openBlock(), _createBlock($setup["UserNavigation"], {
          key: 2,
          menuTile: $setup.listtitle
        }, null, 8 /* PROPS */, ["menuTile"])),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          ($setup.store.getters.Flg != 'UserList' ||
            ($setup.store.getters.Flg == 'UserList' && $setup.store.getters.stationCode == '1000' && $setup.destinationList.length != 0))
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, "Company :"))
            : _createCommentVNode("v-if", true)
        ]),
        ($setup.store.getters.Flg != 'UserList' ||
          ($setup.store.getters.Flg == 'UserList' && $setup.store.getters.stationCode == '1000' && $setup.destinationList.length != 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              ($setup.store.getters.stationCode == '1000')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    class: "adjusting-position form-select des-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDestination) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.destinationList[0], (destination, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "adjusting-option",
                        key: index,
                        value: destination.stationCode
                      }, _toDisplayString(destination.stationCode) + " : " + _toDisplayString(destination.companyName), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */)), [
                    [_vModelSelect, $setup.selectedDestination]
                  ])
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.store.getters.stationCode) + " : " + _toDisplayString($setup.store.getters.companyName), 1 /* TEXT */)),
              ($setup.store.getters.stationCode == '1000')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-primary btnGo",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goSearch()))
                  }, " Go "))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              ($setup.store.getters.Flg != 'UserList')
                ? (_openBlock(), _createElementBlock("th", _hoisted_19))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ]),
      ($setup.userListInfo.length == 0 && $setup.isNoData)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_20, " No data "))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _createElementVNode("tbody", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userListInfo, (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("a", {
                        class: "userinfo-a-link",
                        onClick: ($event: any) => ($setup.userIDClick(info))
                      }, _toDisplayString(info.userId), 9 /* TEXT, PROPS */, _hoisted_25)
                    ]),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(info.givenName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(info.familyName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(info.email), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(info.department), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(info.title), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(info.status), 1 /* TEXT */),
                    ($setup.store.getters.Flg != 'UserList')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                          (info.status.toUpperCase() == 'ACTIVE' ||
                  info.status.toUpperCase() == 'DELETED'
                  )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary status-button",
                                disabled: "",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'active')),
                                nonresize: ""
                              }, " ACTIVATE ", 8 /* PROPS */, _hoisted_33))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary status-button",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'active'))
                              }, " ACTIVATE ", 8 /* PROPS */, _hoisted_34))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.store.getters.Flg != 'UserList')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                          (info.status.toUpperCase() == 'SUSPENDED' ||
                  info.status.toUpperCase() == 'DELETED'
                  )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary status-button",
                                disabled: "",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'suspended'))
                              }, " SUSPEND ", 8 /* PROPS */, _hoisted_36))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary status-button",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'suspended'))
                              }, " SUSPEND ", 8 /* PROPS */, _hoisted_37))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.store.getters.Flg != 'UserList')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                          (info.status.toUpperCase() == 'DELETED')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary status-button",
                                disabled: "",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'deleted'))
                              }, " TERMINATE ", 8 /* PROPS */, _hoisted_39))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary status-button",
                                onClick: ($event: any) => ($setup.updateUserStatus(info.userId, 'deleted'))
                              }, " TERMINATE ", 8 /* PROPS */, _hoisted_40))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.store.getters.Flg != 'UserList')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                          (info.status.toUpperCase() == 'DELETED')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary status-button",
                                disabled: "",
                                onClick: ($event: any) => ($setup.userPermissionClick(info))
                              }, " Edit Permission ", 8 /* PROPS */, _hoisted_42))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary status-button",
                                onClick: ($event: any) => ($setup.userPermissionClick(info))
                              }, " Edit Permission ", 8 /* PROPS */, _hoisted_43))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
    ])
  ]))
}